import {
  AutoCompleteMulti,
  FormInput,
  ISelectType,
  useFetch,
} from "@4uhub/lib4uhub";
import { Grid, FormHelperText } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAutomationRules } from "../../../../../../../store/contexts/AutomationRulesContext";
import { domainValueList } from "../../../../../../../services/domainValue.service";

const translationPath = "components.messages.";

export const TasyAuthField = memo(() => {
  const { t } = useTranslation();
  const [optionsDomainValues, setOptionsDomainValues] = useState<ISelectType[]>(
    []
  );
  const { sendRequest: domainValueRequest } = useFetch(domainValueList);
  const { automation } = useAutomationRules();

  const params = useMemo(() => {
    return { Identifier: "1227" };
  }, []);

  const fetchDomainValues = useCallback(async () => {
    if (!automation || !["22", "23", "24"].includes(String(automation.code)))
      return;
    const { data, success } = await domainValueRequest(params);
    if (data && success) {
      setOptionsDomainValues(
        data.map((d) => ({
          id: d.identifierValue,
          name: d.domainValueName,
        }))
      );
    }
  }, [domainValueRequest]);

  useEffect(() => {
    fetchDomainValues();
  }, [fetchDomainValues]);

  if (
    !automation ||
    !automation.code ||
    !["22", "23", "24"].includes(automation.code)
  )
    return null;

  return (
    <Grid item xs={12} sm={6}>
      <Grid item xs={12} sm={12}>
        <AutoCompleteMulti
          params={params}
          fullWidth
          options={optionsDomainValues}
          name="tasyAuthStatuses"
          label={t(translationPath + "tasyAuthStatuses")}
          getOptionLabel={(option) => option.name}
          size="small"
        />
      </Grid>
    </Grid>
  );
});
